export default __webpack_public_path__ + "static/media/tablet-mockup.8e44fb7b.webp";